export default __webpack_public_path__ + "static/media/service-at-cutis.649c761d.JPG";